import { FC } from 'react';
import { MaybeLoanID } from 'src/common/types';
import { ServerSideModuleData } from '../../GetServerSideProps/utils/getServerSideModuleData';
import { ViewSavedInformation } from './ViewSavedInformation';
import { useViewSavedInformationState } from './useViewSavedInformationState';

export type WiredViewSavedInformationProps = {
    loanID: MaybeLoanID;
    serverFetchedData: Pick<ServerSideModuleData, 'ViewSavedInformation'>;
};

export const WiredViewSavedInformation: FC<WiredViewSavedInformationProps> = ({ loanID, serverFetchedData }) => {
    const { sendToApplication, trackCTAClick, status, experience } = useViewSavedInformationState({
        loanID,
        serverFetchedData,
    });
    return (
        <ViewSavedInformation
            status={status}
            onCTAClick={sendToApplication}
            trackCTAClick={trackCTAClick}
            experience={experience}
        />
    );
};
